import React from 'react';

export default function tv() {
  return (
    <svg width="40" height="38" viewBox="0 0 40 38">
      <path d="M37.37,1.31Q37,1.23,36.46,1.17L35.1,1Q34.29,0.86,33.31.76l-2.12-.2-2.46-.2L26,0.16q-1.4-.08-3-0.12T20,0q-1.5,0-3.08,0t-3,.12l-2.71.18-2.46.2-2.12.2q-1,.1-1.81.23L3.5,1.17Q3,1.23,2.58,1.31l-0.37,0a2.58,2.58,0,0,0-1.58.9A2.52,2.52,0,0,0,0,3.93V26.21a2.45,2.45,0,0,0,.62,1.66,2.82,2.82,0,0,0,1.58.92A118.66,118.66,0,0,0,15,30v3.11L6.29,35.42a1.27,1.27,0,0,0-1,1.47,1.33,1.33,0,0,0,.46.78,1.29,1.29,0,0,0,.87.33H33.33a1.29,1.29,0,0,0,.87-0.33,1.34,1.34,0,0,0,.46-0.78,1.27,1.27,0,0,0-1-1.47L25,33.13V30a118.67,118.67,0,0,0,12.79-1.23,2.82,2.82,0,0,0,1.58-.92A2.45,2.45,0,0,0,40,26.21V3.93a2.48,2.48,0,0,0-.65-1.68,2.68,2.68,0,0,0-1.6-.9ZM5,24V5.92A124.27,124.27,0,0,1,20,5a124.28,124.28,0,0,1,15,.94V24a125.33,125.33,0,0,1-15,1A125.32,125.32,0,0,1,5,24H5Z" />
    </svg>
  );
}



// WEBPACK FOOTER //
// ./src/components/icons/TV/index.js